import { css } from '@emotion/css'
import { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { getGreenEnergy, getSaveCarbon } from './api/api'
import CircleProgressBar from './components/CircleProgressBar'
import Header from './components/header'
import {
    HomepageTopSectionMain,
    SectionContent,
    SectionImg,
    SectionRow
} from './components/styles/Homepage.styled'
import { MyButton } from './components/styles/MyComponents.styled'
import { RenewableProps, SaveCarbonProps } from './types'
import { ValidateAddress } from './validate_address'
import Footer from './components/footer'

export const Homepage = () => {
    const [saveCarbon, setSaveCarbon] = useState<SaveCarbonProps>()
    const [renewable, setRenewable] = useState<RenewableProps>({} as RenewableProps)

    useEffect(() => {
        getGreenEnergy('77479').then((res) => {
            if (res && res.response) {
                setRenewable(res.response)
            }
        })
        getSaveCarbon('77479', 1000).then((res) => {
            if (res && res.data) {
                setSaveCarbon(res.data)
            }
        })
    }, [])

    const handleTry = () => {
        window.scrollTo(0, 0)
    }

    return (
        <>
            <Header />

            <div style={{
                zIndex: -1,
                height: 454,
                backgroundImage: 'url(/images/home_banner.png)',
                backgroundRepeat: 'no-repeat',
                margin: '0 auto',
                backgroundPosition: 'center',
            }} >

                <Container>
                    <HomepageTopSectionMain>
                        <h1>Green Energy</h1>
                        <p>For a greener, Greater Texas</p>
                        <ValidateAddress />
                    </HomepageTopSectionMain>
                </Container>
            </div>

            <div className={css`
            @media(max-width:990px){
                padding:0 10px;
            }
            `}>
                {/* <Container className='mt-5 mb-5 '>
                    <Row>
                        {[...Array(7)].map((_, i) => {
                            return <Col key={i} className='d-flex align-items-center justify-content-center mt-2 mb-2'>
                                <img src={`/images/logos/icon_logo${i}.png`} alt="" className={css`
                                    width:90px;
                                    @media (max-width:990px){
                                        width:60px;
                                    }
                                `} />
                            </Col>
                        })}
                    </Row>
                </Container> */}

                <div className={css`
                background:#f6f6f6;
                padding:20px 0;
            `}>
                    <Container>
                        <SectionRow>
                            <SectionContent>
                                <h2>Boosting Your Renewable Energy</h2>
                                <p>Analyze your renewable energy proportion to understand your reliance on non-renewable sources and reduce your carbon footprint by increasing the use of renewable energy.</p>
                            </SectionContent>
                            <div className={css`
                            width: 45%;
                            flex-shrink: 0;
                            position:relative;
                            padding:0 40px;
                            @media (max-width:990px){
                                width:100%;
                                display:flex;
                                flex-direction:column;
                                align-items:center;
                            }
                        `}>
                                <CircleProgressBar percentage={renewable.renewable_content || 70} width={240} />
                                <div className={css`
                                display:flex;
                                background:#ffffff;
                                border-radius:8px;
                                padding:15px;
                                align-items:center;
                                border:1px solid #ebebeb;
                                gap:10px;
                                width:360px;

                                position:absolute;
                                bottom:-30px;
                                left:120px;
                                @media(max-width:990px){
                                    bottom:-35px;
                                    left:50%;
                                    transform:translateX(-50%);
                                }
                            `}>
                                    <div>
                                        <img src="/images/icon_leaf2.png" alt="" />
                                    </div>
                                    <div>
                                        <div className={css`
                                        font-size: 14px;
                                        font-weight: 600;
                                    `}>Carbon avoided</div>
                                        <div className={css`
                                        font-size: 14px;
                                    `}>1000kWh green energy could avoid <span style={{ color: '#EE730F' }}>{((saveCarbon?.carbon_kg || 0) / 1000).toFixed(2)}</span> tons of co2 </div>
                                        <div className={css`
                                        font-size: 14px;
                                    `}>which would save <span style={{ color: '#EE730F' }}>{saveCarbon?.carbon_tree.toFixed(1) || 0}</span> trees to absorb </div>
                                    </div>
                                </div>
                            </div>
                        </SectionRow>
                    </Container>
                </div>

                <Container>
                    <div className={css`
                    display:flex;
                    justify-content:center;
                    margin:100px 0;
                    align-items:center;
                    @media (max-width:990px){
                        margin:20px 0;
                    }
                `}>
                        <img src="/images/icon_leaf.png" alt=""
                            className={css`
                            width:74px;
                            @media(max-width:990px){
                                width:54px;
                            }
                        `} />
                        <div className={css`
                            font-size:30px;
                            font-weight:700;
                            margin-left:20px;
                            @media (max-width:990px){
                                font-size:24px;
                            }
                    `}>Power up with green energy </div>
                    </div>
                </Container>

                <Container>
                    <SectionRow reverse>
                        <SectionContent>
                            <h2>Reduce Carbon Footprint with Energy Usage Analysis</h2>
                            <p>By analyzing your energy usage and highlighting the proportion of clean sources in your current plan, we provide a detailed analysis of your energy usage. We then recommend electricity plans that reduce your carbon footprint and increase the percentage of clean energy consumed.</p>
                        </SectionContent>
                        <SectionImg>
                            <img src="/images/home_img0.png" alt="" />
                        </SectionImg>
                    </SectionRow>
                </Container>
                <Container>
                    <SectionRow>
                        <SectionContent>
                            <h2>Easy Switching with Our User-Friendly Platform</h2>
                            <p>Our efficient process and intuitive platform make the switch to clean energy a breeze. Begin reducing your carbon footprint today by switching to a recommended energy plan, and start experiencing the benefits of renewable energy.</p>
                        </SectionContent>
                        <SectionImg>
                            <img src="/images/home_img1.png" alt="" />
                        </SectionImg>
                    </SectionRow>
                </Container>

                <Container>
                    <div className={css`
                    display:flex;
                    align-items:center;
                    flex-direction:column;
                    margin:100px 0;
                    gap:30px;
                    @media (max-width:990px){
                        margin:30px 0;
                    }
                `}>
                        <div className={css`
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            `}>
                            <img src="/images/icon_leaf1.png" alt=""
                                className={css`
                                width:86px;
                                @media(max-width:990px){
                                    width:64px;
                                }
                            `} />
                            <div className={css`
                                font-size:30px;
                                font-weight:700;
                                margin-left:20px;
                                @media (max-width:990px){
                                    font-size:24px;
                                }
                            `}>Join Our Mission for a Better Future</div>
                        </div>
                        <p>Our mission is to promote the use of clean energy sources, and with our recommendations, you’ll find it easy to contribute to a better future for our planet. Join us to switch effortlessly to a cleaner energy plan, and you’ll be saving on your bills too.</p>
                        <MyButton onClick={handleTry}>Try Today</MyButton>
                    </div>
                </Container>

                <div style={{ background: '#f6f6f6', padding: '20px 0' }}>
                    <Container>
                        <SectionRow reverse>
                            <SectionContent>
                                <h2>About Us</h2>
                                <p>Green Up Texas is dedicated to promoting the use of clean, renewable energy sources in Texas. By making the switch to clean energy, we can reduce our reliance on fossil fuels, decrease harmful emissions, and create a healthier, more sustainable future for ourselves and generations to come. Join us in our mission to make Texas a cleaner and greener place to live!</p>
                            </SectionContent>
                            <SectionImg>
                                <img src="/images/home_img2.png" alt="" />
                            </SectionImg>
                        </SectionRow>
                    </Container>
                </div>

            </div>

            <Footer />
        </>
    )
}
